<template>
    <span v-if="enableMobile && isMobile" class="flex items-center">
        <em :class="dotColor" class="h-3 w-3 shrink-0 rounded-full" />
    </span>
    <span v-else :class="[background, inline ? '' : 'h-8 px-[6px] py-1']" class="flex items-center gap-2 rounded-[6px] !border-0">
        <em :class="dotColor" class="h-3 w-3 shrink-0 rounded-full" />
        <span :class="color" class="text-nowrap">
            {{ trans('general.assetstatus.' + operability) }}
        </span>
    </span>
</template>
<script setup>
import { trans } from '@/mixins/i18n.js';
import { computed } from 'vue';
import { isMobile } from '@/Utils/UseMedia.js';

const props = defineProps({
    operability: {},
    inline: { type: Boolean, default: false },
    enableMobile: { type: Boolean, default: false },
});

const color = computed(() => (props.operability === 'operable' ? 'text-success' : 'text-danger'));
const background = computed(() => {
    if (props.inline) {
        return 'bg-transparent px-0 badge-inline';
    }

    if (props.operability === 'inoperable') {
        return 'badge-inoperable';
    }

    if (props.operability === 'operable') {
        return 'badge-operable';
    }

    return 'bg-secondary';
});

const dotColor = computed(() => {
    switch (props.operability) {
        case 'operable':
            return 'bg-success';
        case 'inoperable':
            return 'bg-danger';
        default:
            return 'bg-secondary';
    }
});
</script>
<style scoped>
.badge-inline .badge-label {
    font-weight: normal;
    text-transform: capitalize;
}
</style>
